// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161949/js/" + chunkId + "." + {"44":"dceb20d0","225":"a124f16b","481":"ca7f50d0","486":"bd49bbae","770":"713fe257"}[chunkId] + ".0.49156444410259537.chunk.js";
};